import { h } from 'preact'
import { useEffect } from 'preact/compat'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslations } from '../../hooks/useTranslations'
import { CARD_FIELDS } from '../../constants/card'
import SelectBox from '../Common/SelectBox'
import PaymentBreakdown from '../Common/PaymentBreakdown'
import Email from '../CardForm/Fields/Email/index'
import {
  getNumberWithOrdinal,
  makeArrayFromRangeOfNumbers,
} from '../../helpers/common'
import {
  transactionDetailsSelector,
  transactionDetailsUpdate,
} from '../../redux/slice/transactionDetailsSlice'
import './styles.scss'

const PaymentPlan = ({ register, watch, errors, trigger }) => {
  const l10n = useTranslations()
  const dispatch = useDispatch()
  const { culture, currency, directDebit, overrideAmount } = useSelector(
    transactionDetailsSelector,
  )

  const rangeOfDates = directDebit.schedules
    .reduce(
      (acc, item) => [
        ...acc,
        ...makeArrayFromRangeOfNumbers(item.startDay, item.endDay),
      ],
      [],
    )
    .sort((a, b) => a - b)

  const selectOptions = rangeOfDates.map(item => ({
    name: getNumberWithOrdinal(item),
    value: item,
  }))

  const directDebitDate =
    watch(CARD_FIELDS.directDebitDate) || String(rangeOfDates[0])

  useEffect(() => {
    dispatch(
      transactionDetailsUpdate({
        directDebitDate,
      }),
    )

    window.parent?.postMessage?.(
      {
        type: 'MFEStoreDispatch',
        data: {
          actionType: 'transactionDetailsUpdate',
          message: directDebitDate,
        },
      },
      '*',
    )
  }, [directDebitDate])

  return (
    <div className="payment-plan">
      <div className="row">
        <div className="col col-sm-6 col-12">
          <h5 className="text-uppercase payment-plan__title text lead medium nospace">
            {l10n.t('Select monthly payment date')}
          </h5>
          <span className="payment-plan__sub-title small">
            {l10n.t(
              'Some dates may not be available due to booking restrictions',
            )}
          </span>

          <SelectBox
            label={l10n.t('Select Direct Debit Date')}
            selectProps={{
              id: 'direct-debit-dates',
              className: 'direct-debit-select',
              'data-testid': 'direct-debit-select',
              ...register(CARD_FIELDS.directDebitDate),
            }}
            options={selectOptions}
            testIdForOptions="direct-debit-select-option"
          />
          <Email
            register={register}
            trigger={trigger}
            errors={errors}
            label={l10n.t('Account holder email address')}
            type={CARD_FIELDS.directDebitEmail}
          />
        </div>
        <div className="col col-sm-6">
          <h6 className="payment-plan__title text bold small nospace">
            {l10n.t('Payment breakdown')}
          </h6>
          <PaymentBreakdown
            {...{
              directDebit,
              culture,
              currency,
              directDebitDate,
              overrideAmount,
            }}
          />
        </div>
      </div>
    </div>
  )
}

PaymentPlan.propTypes = {
  register: PropTypes.func,
  watch: PropTypes.func,
}

export default PaymentPlan
